import React from 'react'
import PropTypes from 'prop-types'
import ReactSlider from 'react-slider'

const Slider = props => {
    return (
        <ReactSlider
            className="slider"
            thumbClassName="thumb"
            trackClassName="track"
            ariaLabel="Slider Control"
            ariaValuetext={props.value.toString()}
            step={0.01}
            min={0}
            max={1}
            onChange={value => props.onChange(value)}
            value={props.value}
        />
    )
}

Slider.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
}

export default Slider
